/**
* DevExpress Dashboard (_bubble-map-item.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { dataItemLinkSerializationsInfo } from '../../../data-item/metadata/_data-item';
import { colorPropertyName, weightPropertyName } from '../../../metadata/_base-metadata';
import { geoPointMapDashboardItemBaseSerializationsInfo } from './_geo-point-map-item-base';
import { colorLegend, weightedLegend } from './_map-item';
export let bubbleMapWeight = { propertyName: weightPropertyName, modelName: 'Weight', displayName: 'DashboardStringId.WeightCaption', info: dataItemLinkSerializationsInfo };
export let bubbleMapColor = { propertyName: colorPropertyName, modelName: 'Color', displayName: 'DashboardStringId.DescriptionItemColor', info: dataItemLinkSerializationsInfo };
export let bubbleMapDashboardItemSerializationsInfo = geoPointMapDashboardItemBaseSerializationsInfo.concat([bubbleMapWeight, bubbleMapColor, colorLegend, weightedLegend]);
